var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2441",
    "data-name": "Rettangolo 2441",
    width: 24,
    height: 24,
    transform: "translate(0.406)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2140",
    "data-name": "Raggruppa 2140",
    transform: "translate(-0.406)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3480",
    "data-name": "Tracciato 3480",
    d: "M17.656.75H4.156a3,3,0,0,0-3,3v18a1.5,1.5,0,0,0,1.5,1.5h1.43",
    fill: "none",
    stroke: "#1b1b1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3481",
    "data-name": "Tracciato 3481",
    d: "M4.156,5.5h7.25",
    fill: "none",
    stroke: "#1b1b1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3482",
    "data-name": "Tracciato 3482",
    d: "M4.156,9.5h4.86",
    fill: "none",
    stroke: "#1b1b1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3483",
    "data-name": "Tracciato 3483",
    d: "M15.406,9.75V3a2.25,2.25,0,1,1,4.5,0V5.5h-4.5",
    fill: "none",
    stroke: "#1b1b1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3484",
    "data-name": "Tracciato 3484",
    d: "M22.156,19.61l-4.79.96",
    fill: "none",
    stroke: "#1b1b1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3485",
    "data-name": "Tracciato 3485",
    d: "M17.846,15.14l-2.26.95a1.41,1.41,0,0,1-1.12,0,1.52,1.52,0,0,1-.06-2.74l2.26-1.13a2,2,0,0,1,.9-.22,1.8,1.8,0,0,1,.69.13L22.876,14",
    fill: "none",
    stroke: "#1b1b1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3486",
    "data-name": "Tracciato 3486",
    d: "M8.605,20.61H10.2l3.05,2.32a.82.82,0,0,0,1.16.07l4.26-3.52a.83.83,0,0,0,.13-1.16l-2.39-2.59",
    fill: "none",
    stroke: "#1b1b1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3487",
    "data-name": "Tracciato 3487",
    d: "M14.146,13.51l-.25-.21a1.83,1.83,0,0,0-1.06-.3,1.929,1.929,0,0,0-.67.12L8.6,14.6",
    fill: "none",
    stroke: "#1b1b1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3488",
    "data-name": "Tracciato 3488",
    d: "M7.156,21.36h.3a1.14,1.14,0,0,0,1.2-1.08V14.93a1.14,1.14,0,0,0-1.2-1.07h-.3",
    fill: "none",
    stroke: "#1b1b1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3489",
    "data-name": "Tracciato 3489",
    d: "M23.656,21.36h-.25a1.14,1.14,0,0,1-1.2-1.08V14.93a1.14,1.14,0,0,1,1.2-1.07h.3",
    fill: "none",
    stroke: "#1b1b1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientBlack);
export default __webpack_public_path__ + "static/media/client-black.7512838e03e34718525798d18df19115.svg";
export { ForwardRef as ReactComponent };